import { render } from "./ColorPicker.vue?vue&type=template&id=7f43bb0c&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=7f43bb0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f43bb0c"

export default script